import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createRef, useState } from 'react';
import { FileName, FileNamesContainer, FilesFoundLabel, StyledNavPill, StyledNavPillList, StyledNavPillPanel } from "./DeliveryInfoTabs.styled.mjs";
import { XmlSyntaxHighlighter } from "./XmlSyntaxHighlighter.mjs";
import { NavPillListItem } from "../../../core/components/NavPillListItem/index.mjs";
export var DeliveryInfoTabs = function DeliveryInfoTabs(_ref) {
  var xml = _ref.xml,
    fileNames = _ref.fileNames,
    xmlTabLabel = _ref.xmlTabLabel,
    filesTabLabel = _ref.filesTabLabel,
    filesFoundLabel = _ref.filesFoundLabel;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    updateActiveTab = _useState2[1];
  var xmlTab = /*#__PURE__*/createRef();
  var filenamesTab = /*#__PURE__*/createRef();
  var refs = [xmlTab, filenamesTab];
  function handleKeyDown(e) {
    var key = e.key;
    var newActiveTab;
    // left arrow
    if (key === 'ArrowLeft') {
      e.preventDefault();
      newActiveTab = activeTab === 1 ? 2 : activeTab - 1;
    }
    // right arrow
    if (key === 'ArrowRight') {
      e.preventDefault();
      newActiveTab = activeTab === 2 ? 1 : activeTab + 1;
    }
    if (newActiveTab) {
      updateActiveTab(newActiveTab);
      var newActiveTabRef = refs[newActiveTab - 1];
      if (newActiveTabRef.current) {
        newActiveTabRef.current.focus();
      }
    }
  }
  function handleClick(e, newActiveTab) {
    e.preventDefault();
    updateActiveTab(newActiveTab);
  }
  var navPills = [/*#__PURE__*/React.createElement(StyledNavPillPanel, {
    id: "xml-panel",
    "aria-labelledby": "xml-tab",
    hidden: activeTab !== 1
  }, /*#__PURE__*/React.createElement(XmlSyntaxHighlighter, {
    xml: xml
  })), /*#__PURE__*/React.createElement(StyledNavPillPanel, {
    id: "filenames-panel",
    "aria-labelledby": "filenames-tab",
    hidden: activeTab !== 2
  }, /*#__PURE__*/React.createElement(FileNamesContainer, {
    "data-testid": "delivery-info-dialog-filenames-content"
  }, /*#__PURE__*/React.createElement(FilesFoundLabel, null, filesFoundLabel), fileNames.map(function (name) {
    return /*#__PURE__*/React.createElement(FileName, {
      key: name
    }, name);
  })))];
  return /*#__PURE__*/React.createElement(StyledNavPill, {
    list: /*#__PURE__*/React.createElement(StyledNavPillList, null, /*#__PURE__*/React.createElement(NavPillListItem, {
      id: "xml-tab",
      "data-testid": "delivery-info-dialog-xml-tab",
      ref: xmlTab,
      active: activeTab === 1,
      label: xmlTabLabel,
      href: "#xml-panel",
      "aria-controls": "xml-panel",
      onClick: function onClick(e) {
        return handleClick(e, 1);
      },
      onKeyDown: handleKeyDown
    }), /*#__PURE__*/React.createElement(NavPillListItem, {
      id: "filenames-tab",
      "data-testid": "delivery-info-dialog-filenames-tab",
      ref: filenamesTab,
      active: activeTab === 2,
      label: filesTabLabel,
      href: "#filenames-panel",
      "aria-controls": "filenames-panel",
      onClick: function onClick(e) {
        return handleClick(e, 2);
      },
      onKeyDown: handleKeyDown
    }))
  }, navPills[activeTab - 1]);
};